import gql from 'graphql-tag';

export default gql`
  fragment letterStatusChangeActivityFragment on LetterStatusChangeActivity {
    letterStatus
    letterStatusText
  }
`;
